<!-- <input
#input
(ngModelChange)="onChange($event)"
[(ngModel)]="date"
[attr.aria-label]="label"
[attr.required]="required?'required':null"
[class.is-invalid]="isInvalid()"
[disabled]="disabled"
[id]="id"
[min]="minDate"
[placeholder]="placeholder"
class="form-control"
type="date"
/> -->
<div id="sam4Date" >
  <mat-form-field class="form-control" [class.force-focus]="input_focused">
    @if (input_focused ? false : !date) {
      <mat-label><span class="date-label" (click)="focusToInput()">{{placeholder}}</span></mat-label>
    }
    <input matInput [matDatepicker]="picker"
      (dateChange)="eventChange($event)"
      (dateInput)="eventChange($event)"
      [attr.aria-label]="label"
      [attr.required]="required?'required':null"
      [attr.aria-invalid]="(ariaInvalid ?? isInvalid()) ? 'true' : null"
      [attr.aria-describedby]="ariaDescribedBy"
      [class.is-invalid]="isInvalid()"
      [class.input-data]="date"
      [disabled]="disabled"
      [id]="id || ('sam4-date-comp-' + idCnt)"
      [min]="minDate"
      [max]="maxDate"
      class="date-input"
      (focus)="setInputFocus(true)"
      (blur)="setInputFocus(false)"
      [value]="input_focused ? undefined : getValue()"
      >
    <mat-datepicker-toggle matIconSuffix [for]="picker" class="toggler"
            [ngClass]="{
                '!tw-text-white': ('intel' | isOrg:'reverse'),
                '!tw-text-black': 'intel' | isOrg
            }"
      [disabled]="disabled"
    ></mat-datepicker-toggle>
    <mat-datepicker #picker class="picker"></mat-datepicker>
  </mat-form-field>
</div>
